import { useResource } from "./useResource";
import { LOAN_REASONS } from "../../services/apiRoutes";

export const useLoanReasons = () => {
  return useResource(LOAN_REASONS, {
    PersonalLoan: [],
    CarLoan: [],
    LineOfCredit: [],
  });
};